module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"lets_go":"Get started","plan_adventure":"Plan your adventure.","efficient":"Efficient organization"},"de":{"lets_go":"Los geht\u0027s","plan_adventure":"Plane dein Abenteuer.","efficient":"Effiziente Ordnung"}}')
  delete Component.options._Ctor
}
